
$(document).ready(function () {
    $("form.AdresForm").live("submit", function (e) {
        e.preventDefault();
        $form = $(this);

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            beforeSend: function () {
                GenerateLocalLoading($(".portlet-body form.AdresForm"), "show");
            },
            success: function (data) {
                if (data.Sonuc == true) {
                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").addClass("alert-success").show().find("span").html(data.IslemSonucAciklama);
                    $(".CloseAfter").hide();

                    $(".AdressList").hide();

                    $.ajax({
                        type: "GET",
                        url: "/User/AdressInfo",
                        success: function (dta) {
                            $(".AdressList").html(dta);
                            $(".AdressList").fadeIn("fast");
                        }
                    });

                    $form.remove();
                }
                else {
                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(data.IslemSonucAciklama);

                    if (isMobile(true)) {
                        $('html, body').animate({ scrollTop: 280 }, 'slow');
                    }
                }
            },
            error: function (data) {
                $("#AlertResult").addClass("alert-error").show().find("span").html(data.ResultDescription[0]);
            },
            complete: function () {
                GenerateLocalLoading($(".portlet-body form.AdresForm"), "hide");
            }
        });

        return false;
    });

    $(".Foreign").change(function () {
        if ($(".Foreign").attr("checked") == "checked") {
            $(".tcno").hide("slow");
        }
        else {
            $(".tcno").show("slow");
        }
    });

    $(".adrestipradio").live("change", function () {

        if ($("#AdresTipi2").is(":checked")) {
            $(".vergi").show("slow");
            $(".bireyselFatura").hide("slow");
        }
        else {
            $(".vergi").hide("slow");
            $(".bireyselFatura").show("slow");
        }

        //if ($("#AdresTipi3").is(":checked")) {
        //    $(".bireyselFatura").show("slow");
        //} else {
        //    $(".bireyselFatura").hide("slow");
        //}
    });

    // ILCELERI GETIR
    if ($(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") != "TR") {

        $(".ddl_sehir, .ddl_ilce").attr('disabled', true);
        $(".ddl_sehir, .ddl_ilce").css('opacity', "0.5");
    }

    $(".ddl_ulke").live("change", function () {

        if ($(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") == "TR" || $(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") == "KKTC") { // TR

            $(".tr_group").show("slow");
            $(".stateDiv").hide("slow");
            $(".cityDiv").hide("slow");

        }

        if ($(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") != "TR" && $(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") != "KKTC" && $(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") != "CA" && $(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") != "US") { //Rest of world

            $(".tr_group").hide("slow");
            $(".stateDiv").hide("slow");
            $(".cityDiv").show("slow");

        }
        if ($(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") == "CA" || $(".ddl_ulke option[value='" + $(this).val() + "']").attr("data-code") == "US") { //USA & CA

            $(".tr_group").hide("slow");
            $(".stateDiv").show("slow");
            $(".cityDiv").show("slow");
        }


    });

    $(".ddl_sehir").live("change", function () {

        var seciliSehirOID = $(this).val();

        if (seciliSehirOID != undefined && seciliSehirOID != "") {

            $(".ajaxilce").show();

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + '/p/User/GetTowns',
                data: 'cityid=' + seciliSehirOID,
                dataType: 'json',
                success: function (dt) {

                    var icerik = "";
                    $('#TownID option').remove();

                    $('#TownID')
                        .append($("<option selected='selected' ></option>")
                            .attr("value", "")
                            .text("Lütfen Seçin"));


                    $('#TownID').parent().find("span").html("Lütfen Seçin");

                    for (var i = 0; i < dt.length; i++) {


                        $('#TownID')
                            .append($("<option></option>")
                                .attr("value", dt[i].ID)
                                .text(dt[i].Name));

                    }

                    $(".ajaxilce").hide();


                }
            });

        }
        else {

            $('#TownID option:gt(0)').remove();
        }

    });

    $(".ddl_ilce").live("change", function () {

        var seciliIlceOID = $(this).val();

        if (seciliIlceOID != undefined && seciliIlceOID != "") {

            $(".ajaxilce").show();

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + '/p/User/GetQuarters',
                data: 'townID=' + seciliIlceOID,
                dataType: 'json',
                success: function (dt) {

                    var icerik = "";
                    $('#QuarterID option').remove();

                    $('#QuarterID')
                        .append($("<option selected='selected' ></option>")
                            .attr("value", "")
                            .text("Lütfen Seçin"));


                    $('#QuarterID').parent().find("span").html("Lütfen Seçin");

                    for (var i = 0; i < dt.length; i++) {


                        $('#QuarterID')
                            .append($("<option></option>")
                                .attr("value", dt[i].ID)
                                .text(dt[i].Name));

                    }

                    $(".ajaxilce").hide();


                }
            });

        }
        else {

            $('#QuarterID option:gt(0)').remove();
        }

    });

    $(".ItemDelete").live("click", function () {

        $silinecekSatir = $(this).closest("fieldset");

        $('#myModal .modal-body').html($(this).attr("data-name") + " <span id='Silinecek' data-action='" + $(this).attr("data-action") + "' data-rel='" + $(this).attr("data-rel") + "'> </span>");
        $('#myModal').modal('show');

        return false;
    });

    // Silmeyi Onayla
    $("#SilmeOnayla").click(function () {

        var dataProp = "id";

        if ($('#myModal .modal-body #Silinecek').attr("data-prop")) {
            dataProp = $('#myModal .modal-body #Silinecek').attr("data-prop");
        }

        $.ajax({
            type: "POST",
            url: $('#myModal .modal-body #Silinecek').attr("data-action"),
            data: dataProp + "=" + $('#myModal .modal-body #Silinecek').attr("data-rel"),
            cache: false,
            success: function (data) {

                if (data == "true") {

                    $silinecekSatir.css("background-color", "yellow");

                    $('#myModal').modal('hide');

                    $silinecekSatir.hide("slow");

                }
                else {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


    });

});